import styled from 'styled-components';

export const ModalHeaderContainer = styled.section`
    font-size: 12px;
    padding: 10px;

    @media screen and (max-width: ${props => props.theme.mobile}) {
        flex-direction: column;
    }

    svg {
        width: 150px;
        margin-right: 20px;
    }

    @media screen and (max-width: ${props => props.theme.mobile}) {
        flex-direction: column;
        text-align: center;
        justify-content: center;

        svg {
            margin-right: 0;
        }
    }
`;



// WEBPACK FOOTER //
// ./src/components/pages/interstitiel/ModalHeaderComponentStyle.js